module.exports = __webpack_public_path__ + "static/pickbazar-install-59831b8b05857c7da9a95d8dd21dac31.png";